import React, { lazy } from "react";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { FLEECE_RAW_ORDER } from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// 🔁 Lazy-load fleece inventory components
const FleeceInventoryList = lazy(() => import("app/pages/Inventory/fleeceInventory/List"));
const AddFleeceStock = lazy(() => import("app/pages/Inventory/fleeceInventory/Add"));
const EditFleeceStock = lazy(() => import("app/pages/Inventory/fleeceInventory/Edit"));
const ViewDetails = lazy(() => import("app/pages/Inventory/fleeceInventory/List/Approval/ViewDetails"));
const IssueRawOrderFleece = lazy(() => import("app/pages/Inventory/fleeceInventory/IssueRawOrder"));

export const fleeceInventoryRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "fleece_paper_inventory", "view"],
      },
    ],
    routes: [
      {
        path: "/inventory/fleece",
        element: LoadablePage(FleeceInventoryList),
      },
      {
        path: "/inventory/fleece/add",
        element: LoadablePage(AddFleeceStock),
      },
      {
        path: "/inventory/fleece/edit",
        element: LoadablePage(EditFleeceStock),
      },
      {
        path: "/inventory/fleece-approval/view-details/:id/:invoiceId",
        element: LoadablePage(ViewDetails),
      },
      {
        path: FLEECE_RAW_ORDER,
        element: LoadablePage(IssueRawOrderFleece),
      },
    ],
  },
];
